// extracted by mini-css-extract-plugin
export default {"root":"qNrhh","h1":"RQn1m","h2":"RWK4s"};